import React from "react";
import {
  AdminCarbonAvoidanceProjectSubType,
  AdminCarbonAvoidanceProjectType,
} from "@ecologi/shared";
import CaptureIcon from "@ecologi/assets/icons/ProjectInsights/capture.svg";
import CommunityIcon from "@ecologi/assets/icons/ProjectInsights/community.svg";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";
import RenewablesIcon from "@ecologi/assets/icons/ProjectInsights/renewables.svg";
import TransportIcon from "@ecologi/assets/icons/ProjectInsights/transport.svg";
import WetlandsIcon from "@ecologi/assets/icons/ProjectInsights/wetlands.svg";
import { ProjectVisualsType } from "./project-visuals";

const PATH = "/images/app/forest/carbon_avoidance/pictograms/";

export const carbonAvoidanceVisuals: Record<
  AdminCarbonAvoidanceProjectType,
  ProjectVisualsType
> = {
  CAPTURE: {
    icon: <CaptureIcon />,
    pictogram: `${PATH}capture.svg`,
  },
  COMMUNITY: {
    icon: <CommunityIcon />,
    pictogram: `${PATH}community.svg`,
  },
  FORESTRY: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
  RENEWABLES: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  TRANSPORT: {
    icon: <TransportIcon />,
    pictogram: `${PATH}transport.svg`,
  },
  WETLANDS: {
    icon: <WetlandsIcon />,
    pictogram: `${PATH}wetlands.svg`,
  },
  // Geothermal is waiting on finalised designs and currently shares the renewables icon.
  GEOTHERMAL: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
};

export const carbonAvoidanceSubTypeVisuals: Record<
  AdminCarbonAvoidanceProjectSubType,
  ProjectVisualsType
> = {
  // Biomass, Hydro and Solar are waiting on finalised designs and currently share the renewables icon.
  BIOMASS: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  HYDRO: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  SOLAR: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}renewables.svg`,
  },
  WIND: {
    icon: <RenewablesIcon />,
    pictogram: `${PATH}wind.svg`,
  },
  FOREST_PROTECTION: {
    icon: <ForestryIcon />,
    pictogram: `${PATH}forestry.svg`,
  },
};
